import type { Control, FieldErrors, FieldValues, UseFormRegister } from 'react-hook-form';
import FormInput from '../CoreComponents/ReactFormComponents/FormInput';
import FormDDL from '../CoreComponents/ReactFormComponents/FormDDL';
import type { FieldDef } from './types';

type Props = {
    field: FieldDef;
    register: UseFormRegister<FieldValues>;
    control: Control<FieldValues>;
    errors: FieldErrors;
};

export function FieldRenderer({ field, register, control, errors }: Props) {
    if (field.kind === 'select') {
        return (
            <FormDDL
                dataTestId={`task-${field.key}-input`}
                required
                errors={errors}
                defaultValue=""
                inputKey={field.key}
                name={field.key}
                control={control}
                label={field.label}
                options={field.options}
            />
        );
    }

    return (
        <FormInput
            dataTestId={`task-${field.key}-input`}
            required
            errors={errors}
            defaultValue=""
            inputKey={field.key}
            registeredProps={register(field.key as any)}
            label={field.label}
            placeholder={field.placeholder}
        />
    );
}
